import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import './StickyFooter.scss';

const FOOTER_NAV_HEIGHT = 44; // height of the bottom FooterNav bar (px)

const StickyFooter = props => {
  const { showPadding, children, bottom, ...rest } = props;
  const [width, setWidth] = useState(0);
  const divRef = useRef(null);

  useEffect(() => {
    const node = divRef.current;
    if (!node) return;
    // Observe the parent's width so the fixed footer stays in sync on resize.
    // The parent is in normal flow, so its width reflects the content column.
    const target = node.parentElement || node;
    const ro = new ResizeObserver(() => {
      setWidth(target.getBoundingClientRect().width);
    });
    setWidth(target.getBoundingClientRect().width);
    ro.observe(target);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={divRef}
      style={
        width
          ? { position: 'fixed', width: width, bottom: `calc(${showPadding ? 0 : FOOTER_NAV_HEIGHT}px + var(--bottom-padding))` }
          : undefined
      }
    >
      {children}
    </div>
  );
};

const container = connect(
  state => ({
    showPadding: state.app.get('showPadding')
  }),
  {}
)(StickyFooter);

export default container;
